export default __webpack_public_path__ + "static/media/681.3e99085b.png";